export default "__VITE_ASSET__e4657bd9__"